import { render, staticRenderFns } from "./ChangeOrderCustomerModal.vue?vue&type=template&id=5b1e3b3c"
import script from "./ChangeOrderCustomerModal.vue?vue&type=script&lang=js"
export * from "./ChangeOrderCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports